import { render, staticRenderFns } from "./modalImagen.vue?vue&type=template&id=6d58246f&"
import script from "./modalImagen.vue?vue&type=script&lang=js&"
export * from "./modalImagen.vue?vue&type=script&lang=js&"
import style0 from "./modalImagen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports